import React, { useState, useEffect, Fragment } from "react";
import makeStyles from '@mui/styles/makeStyles';
import {Typography, TextField, MenuItem, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Divider, CircularProgress, Grid} from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import LoginMenu from "../../../../../components/LoginMenu/LoginMenu";
import CustomizedSnackbar from "../../../../../components/CustomizedSnackbar/CustomizedSnackbar";
import Autocomplete from '@mui/material/Autocomplete';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "rgb(29, 95, 152)", //theme.palette.common.black,
    color: theme.palette.common.white,
    fontWeight: 500,
    border: '1px solid white'
  },
  body: {
    fontSize: 14,
    border: '1px solid rgb(29, 95, 152)'
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 750,
  },
});

const R46Reports = (props) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [showTableFilter, setShowTableFilter] = useState(false);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [isDownloadPdf, setIsDownloadPdf] = useState(false);
  const [applicationStatusId, setApplicationStatusId] = useState(1);
  const [isLoginMenu, setIsLoginMenu] = useState(false);
  const [isReload, setIsReload] = useState(false);
  const [isOpenSnackbar, setIsOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("");
  const [coursesMenuItems, setCoursesMenuItems] = useState([]);
  const [courseId, setCourseId] = useState("");
  const [courseIdError, setCourseIdError] = useState("");
  const [effectiveDateMenuItems, setEffectiveDateMenuItems] = useState([]);
  const [effectiveDate, setEffectiveDate] = useState("");
  const [timetableData, setTimetableData] = useState([]);

  const handleOpenSnackbar = (msg, severity) => {
    setIsOpenSnackbar(true);
    setSnackbarMessage(msg);
    setSnackbarSeverity(severity);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {  return; }
    setIsOpenSnackbar(false);
  };

  const getEffectiveDates = async (courseId) => {
    let data = new FormData();
    data.append("courseId", courseId);
    setIsLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C110CommonProgrammesGroupTimeTableEffectiveDatesView`;
    await fetch(url, {
      method: "POST",
      body:data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            setEffectiveDateMenuItems(json.DATA || []);
            let effectiveDateMenuItems = json.DATA || [];
            if(effectiveDateMenuItems.length>0){
              getData(effectiveDateMenuItems[0].label);
              setEffectiveDate(effectiveDateMenuItems[0].label);
            }
          } else {
            //alert(json.SYSTEM_MESSAGE + '\n' + json.USER_MESSAGE);
            handleOpenSnackbar(<span>{json.SYSTEM_MESSAGE}<br/>{json.USER_MESSAGE}</span>,"error");
          }
          console.log("getEffectiveDates", json);
        },
        (error) => {
          if (error.status === 401) {
            setIsLoginMenu(true);
            setIsReload(false);
          } else {
            //alert('Failed to fetch, Please try again later.');
            handleOpenSnackbar("Failed to fetch, Please try again later.","error");
            console.log(error);
          }
        }
      );
    setIsLoading(false);
  };

  const getData = async (effectiveDate) => {
    setIsLoading(true);
    let data = new FormData();
    data.append("effectiveDate", effectiveDate);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C110StudentTimeTableView`;
    await fetch(url, {
      method: "POST",
      body:data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            setTimetableData(json.DATA || []);
          } else {
            //alert(json.SYSTEM_MESSAGE + '\n' + json.USER_MESSAGE);
            handleOpenSnackbar(<span>{json.SYSTEM_MESSAGE}<br/>{json.USER_MESSAGE}</span>,"error");
          }
          console.log("getData", json);
        },
        (error) => {
          if (error.status === 401) {
            setIsLoginMenu(true);
            setIsReload(true);
          } else {
            //alert('Failed to fetch, Please try again later.');
            handleOpenSnackbar("Failed to fetch, Please try again later.","error");
            console.log(error);
          }
        }
      );
    setIsLoading(false);
  };

  const handleSetCourse = (value) => {
    setCourseId(value);
    setCourseIdError("");
    setEffectiveDate("");
    setTimetableData([]);
    if(value) {
      getEffectiveDates(value.id);
    }
  };

  const onHandleChange = (e) => {
    const { name, value } = e.target;
    const errName = `${name}Error`;
    let regex = "";
    switch (name) {
        case "effectiveDate":
            setTimetableData([]);
            getData(value);
        break;
    default:
        break;
    }
    if (name === "effectiveDate") {
      setEffectiveDate(value);
    }
  };

  const isCourseValid = () => {
    let isValid = true;
    if (!courseId) {
        setCourseIdError("Please select course.");
        document.getElementById("courseId").focus();
        isValid = false;
    } else {
        setCourseIdError("");
    }
    return isValid;
  };

  useEffect(() => {
    props.setDrawerOpen(false);
    getEffectiveDates();
  }, []);

  return (
    <Fragment>
      <LoginMenu
        reload={isReload}
        open={isLoginMenu}
        handleClose={() => setIsLoginMenu(false)}
      />
      <div
        style={{
          padding: 20,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography
            style={{
              color: "#1d5f98",
              fontWeight: 600,
              textTransform: "capitalize",
            }}
            variant="h5"
          >
            Course Timetable
          </Typography>
        </div>
        <Divider
          style={{
            backgroundColor: "rgb(58, 127, 187)",
            opacity: "0.3",
          }}
        />
        <br/>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <Grid size={{ xs: 12, md: 4 }}>
            <TextField
              id="effectiveDate"
              name="effectiveDate"
              variant="outlined"
              label="Effective Date"
              onChange={onHandleChange}
              value={effectiveDate}
              required
              fullWidth
              select
            >
              {effectiveDateMenuItems && !isLoading ?
                effectiveDateMenuItems.map((dt, i) => (
                  <MenuItem
                    key={"effectiveDateMenuItems"+dt.id}
                    value={dt.label}
                  >
                    {dt.label}
                  </MenuItem>
                ))
              :
                <Grid
                  container
                  justifyContent="center">
                    <CircularProgress />
                  </Grid>
              }
            </TextField>
          </Grid>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell style={{borderLeft: '1px solid rgb(29, 95, 152)'}}>&nbsp;</StyledTableCell>
                  <StyledTableCell align="center">Monday</StyledTableCell>
                  <StyledTableCell align="center">Tuesday</StyledTableCell>
                  <StyledTableCell align="center">Wednesday</StyledTableCell>
                  <StyledTableCell align="center">Thursday</StyledTableCell>
                  <StyledTableCell align="center">Friday</StyledTableCell>
                  <StyledTableCell align="center">Saturday</StyledTableCell>
                  <StyledTableCell align="center" style={{borderRight: '1px solid rgb(29, 95, 152)'}}>Sunday</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {timetableData.length > 0 ?
                  timetableData.map((row, index) => (
                    <StyledTableRow key={row+index}>
                      <StyledTableCell component="th" scope="row">{row.time.split("-").map((dt, i)=><Fragment key={"time"+dt+i}>{i != 0 ? <Fragment><br/></Fragment> : ""}<span style={{whiteSpace:"nowrap"}}>{dt}</span></Fragment>)}</StyledTableCell>
                      <StyledTableCell align="center">{row.Monday.split(",").map((dt, i)=><Fragment key={"Monday"+dt+i}>{i != 0 ? <Fragment><br/><br/></Fragment> : ""}{dt}</Fragment>)}</StyledTableCell>
                      <StyledTableCell align="center">{row.Tuesday.split(",").map((dt, i)=><Fragment key={"Tuesday"+dt+i}>{i != 0 ? <Fragment><br/><br/></Fragment> : ""}{dt}</Fragment>)}</StyledTableCell>
                      <StyledTableCell align="center">{row.Wednesday.split(",").map((dt, i)=><Fragment key={"Wednesday"+dt+i}>{i != 0 ? <Fragment><br/><br/></Fragment> : ""}{dt}</Fragment>)}</StyledTableCell>
                      <StyledTableCell align="center">{row.Thursday.split(",").map((dt, i)=><Fragment key={"Thursday"+dt+i}>{i != 0 ? <Fragment><br/><br/></Fragment> : ""}{dt}</Fragment>)}</StyledTableCell>
                      <StyledTableCell align="center">{row.Friday.split(",").map((dt, i)=><Fragment key={"Friday"+dt+i}>{i != 0 ? <Fragment><br/><br/></Fragment> : ""}{dt}</Fragment>)}</StyledTableCell>
                      <StyledTableCell align="center">{row.Saturday.split(",").map((dt, i)=><Fragment key={"Saturday"+dt+i}>{i != 0 ? <Fragment><br/><br/></Fragment> : ""}{dt}</Fragment>)}</StyledTableCell>
                      <StyledTableCell align="center">{row.Sunday.split(",").map((dt, i)=><Fragment key={"Sunday"+dt+i}>{i != 0 ? <Fragment><br/><br/></Fragment> : ""}{dt}</Fragment>)}</StyledTableCell>
                    </StyledTableRow>
                  ))
                  :
                  isLoading ?
                  <StyledTableRow key={1}>
                    <StyledTableCell component="th" scope="row" colSpan={8}><center><CircularProgress/></center></StyledTableCell>
                  </StyledTableRow>
                  :
                  <StyledTableRow key={1}>
                    <StyledTableCell component="th" scope="row" colSpan={8}><center><b>No Data</b></center></StyledTableCell>
                  </StyledTableRow>
                }
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <CustomizedSnackbar
          isOpen={isOpenSnackbar}
          message={snackbarMessage}
          severity={snackbarSeverity}
          handleCloseSnackbar={() => handleCloseSnackbar()}
        />
      </div>
    </Fragment>
  );
};

export default R46Reports;
